import { render } from "./AhOvAssignUser.vue?vue&type=template&id=58bbadce&scoped=true"
import script from "./AhOvAssignUser.vue?vue&type=script&lang=js"
export * from "./AhOvAssignUser.vue?vue&type=script&lang=js"

import "./AhOvAssignUser.vue?vue&type=style&index=0&id=58bbadce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58bbadce"]])

export default __exports__